// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorAlt": `#052b52`,
	"colorBackground": `#fff`,
	"colorBlack": `#000`,
	"colorBlockquote": `#052b52`,
	"colorBlue": `#024cbc`,
	"colorBlueAlt": `#0345a7`,
	"colorBlueDark": `#052b52`,
	"colorBlueDark2": `#0b4497`,
	"colorBlueDark3": `#0a3677`,
	"colorBlueHighlight": `#e4f7fd`,
	"colorDefault": `#000`,
	"colorDisabled": `#9b9b9b`,
	"colorGrayBackground": `#fafafa`,
	"colorGrayBorder": `#bebebe`,
	"colorGrayDisabled": `#9b9b9b`,
	"colorGrayLight": `#f6f6f6`,
	"colorGrayLight2": `#e9e9e9`,
	"colorGrayLight3": `#737373`,
	"colorGrayLight4": `#fafafa`,
	"colorGrayLight5": `#faf7f7`,
	"colorGreyDisabled": `#9b9b9b`,
	"colorHighlight": `#024cbc`,
	"colorHover": `#052b52`,
	"colorHr": `#f6f6f6`,
	"colorLink": `#024cbc`,
	"colorPlaceholder": `#e9e9e9`,
	"colorRed": `#d63d3d`,
	"colorTeal": `#4ee4b3`,
	"colorTeale": `#4ee4b3`,
	"colorWhite": `#fff`,
	"colorWhiteOff": `#f6f6f6`
};
module.exports = ___CSS_LOADER_EXPORT___;
